/*
 *   File : empty.js
 *   Author : https://evoqins.com
 *   Description : No data found component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React from 'react'

const EmptyScreen = (props) => {
    return (
        <div className='text-center mt-5'>
            <img src={require("../../Assets/Image/empty.webp")}
                draggable={false}
                width={props.width}
                alt='empty' />
            <h3 className='pb-5 mb-0 pt-4 e-primary-font-poppins e-font-20 line-height-22px e-text-eerie-black e-font-weight-600'>
                {props.message}
            </h3>
        </div>
    )
}

export default EmptyScreen;